export default "__VITE_ASSET__B207Tk5l__"